<template>
    <!-- eslint-disable-next-line -->
    <Loading
        :class="{ 'loading-text': loadingText, 'text-white': textLight }"
        :active.sync="options.isLoading"
        :loader="options.loader"
        :is-full-page="options.fullPage"
        :background-color="options.backgroundColor"
        :color="options.color"
        :opacity="options.opacity"
        :width="options.width"
        :height="options.height"
        :z-index="zIndex"
    />
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'Loader',
    components: {
        Loading
    },
    props: {
        options: {
            type: Object,
            default: function () {}
        },
        textLight: Boolean,
        textDark: Boolean,
        loadingText: Boolean
    },
    computed: {
        zIndex: function () {
            if (this.options.zIndex !== undefined) {
                return this.options.zIndex;
            }

            return 9999;
        }
    }
};

</script>

<style>
    .loading-text .vld-icon:after {
        content: 'Please wait ...';
        display: block;
        margin-left: -7px;
        font-weight: 700;
        line-height: 0;
    }
</style>
